import React from 'react';
import Body from './Body/Body';
import Footer from './Footer/Footer';
import Header from './Header/Header';

const MainCom = () => {
    return (
        <div >
        <Header></Header>
        <Body></Body>
        
        
        </div>
    );
};

export default MainCom;